import { uid } from '@/firebase'
import { toData } from '@/helpers/fs/toData'
import { UserFreeFeatureToggle } from '@/helpers/fs/userFreeFeatureToggle'
import { UserPublicBookingViewSetting } from '@/helpers/fs/userPublicBookingViewSetting'
import { AuthorizedService } from '@/helpers/fs/users/authorizedService'
import {
  FSAuthorizedService,
  FSUserFreeFeatureToggles,
  FSUserPublicBookingViewSetting,
  OauthServiceName
} from '@WombatTechnology/nitte-time-lib'
import { defineStore } from 'pinia'

type SlackBotAuthorizedService = FSAuthorizedService & {
  mediatoryNotificationChannel?: FSAuthorizedService['notificationChannel']
}

// State
// FIXME: VuexのSettingStoreを全部こっちに移しきれていない
type State = {
  userPublicBookingViewSetting: FSUserPublicBookingViewSetting | null
  userAuthorizedServices: FSAuthorizedService[] | null
  freeFeatureToggles: FSUserFreeFeatureToggles | null
  isSpSettingMenuExpanded: boolean
}

export const useSettingStore = defineStore('setting', {
  state: (): State => {
    return {
      userPublicBookingViewSetting: null,
      userAuthorizedServices: null,
      freeFeatureToggles: null,
      isSpSettingMenuExpanded: false
    }
  },
  actions: {
    toggleSideMenu() {
      this.isSpSettingMenuExpanded = !this.isSpSettingMenuExpanded
    },
    async setup() {
      this.sync(
        'userPublicBookingViewSetting',
        UserPublicBookingViewSetting.doc(uid()!)
      )
      this.sync('userAuthorizedServices', AuthorizedService.collection(uid()!))

      // NOTE: syncだと間に合わない場合があるので同期的に初期化する。
      this.freeFeatureToggles = await toData<FSUserFreeFeatureToggles>(
        UserFreeFeatureToggle.doc(uid()!)
      )
      this.sync('freeFeatureToggles', UserFreeFeatureToggle.doc(uid()!))
    },
    authorizedWith(service: OauthServiceName) {
      return this.userAuthorizedServices?.some((as) => as.service === service)
    },
    // 新OAuth (bot token) での連携済みかどうか。
    // OauthTokens はフロントから読まず、AuthorizedServices/slack_bot で判定する。
    hasNewSlackAuth(): boolean {
      return this.authorizedWith('slack_bot') === true
    },
    // 旧OAuth (incoming webhook) のみ連携されているか。
    hasLegacySlackAuth(): boolean {
      return this.authorizedWith('slack') === true
    },
    // AuthorizedServices が Firestore から読み込まれたか。
    isAuthorizedServicesLoaded(): boolean {
      return this.userAuthorizedServices !== null
    },
    // slack_bot のMediatory通知先チャンネル（未設定なら null）。
    slackBotMediatoryNotificationChannel(): FSAuthorizedService['notificationChannel'] {
      const svc = this.userAuthorizedServices?.find(
        (as) => as.service === 'slack_bot'
      ) as SlackBotAuthorizedService | undefined
      return svc?.mediatoryNotificationChannel ?? null
    },
    isToggled(key: keyof FSUserFreeFeatureToggles): boolean {
      return this.freeFeatureToggles?.[key] ?? false
    }
  }
})
